<template>
  <div class="navigation-bar">
    <nav class="columns">
      <p class="column has-text-centered navigation-item">
        <router-link :to="{name: 'Feed'}">
          {{ $t("nav.feed") }}
        </router-link>
      </p>
      <p class="column has-text-centered navigation-item">
        <router-link :to="{name: 'LeaderBoard'}">
          {{ $t("nav.leaderboard") }}
        </router-link>
      </p>
      <p class="column has-text-centered navigation-item">
        <router-link :to="{name: 'MatchList'}">
          {{ $t("nav.matchs") }}
        </router-link>
      </p>
      <!--p class="column has-text-centered navigation-item">
        <router-link :to="{name: 'Tournaments'}">
          {{ $t("nav.tournaments") }}
        </router-link>
      </p-->
      <p class="column has-text-centered">
        <router-link :to="{name: 'Home'}">
          <img src="@/assets/logo.png" alt="" style="height: 65px; width: 135px;">
        </router-link>
      </p>
      <p class="column has-text-centered navigation-item">
        <router-link :to="{name: 'Rules'}">
          {{ $t("nav.rules") }}
        </router-link>
      </p>
      <p class="column has-text-centered navigation-item">
        <router-link :to="{name: 'About'}">
          {{ $t("nav.about") }}
        </router-link>
      </p>
      <!--p class="column has-text-centered navigation-item">
        <router-link :to="{name: 'Guild'}">
          {{ $t("nav.guild") }}
        </router-link>
      </p-->
      <p class="column has-text-centered navigation-item">
        <!--router-link :to="{name: 'MyAccount'}" v-if="isLoggedIn === true">
          {{ $t("nav.logged") }}
        </router-link-->
        <router-link :to="{name: 'User', params: { username: me }}" v-if="isLoggedIn === true">
          {{ $t("nav.logged") }}
        </router-link>
        <router-link :to="{name: 'Auth'}" v-else>
          {{ $t("nav.unlogged") }}
        </router-link>
      </p>
    </nav>
  </div>
</template>

<script>
import { EventBus } from '@/services/bus'
import AuthService from '@/services/authService'
export default {
  data () {
    return {
      isLoggedIn: null,
      me: ''
    }
  },
  created: function () {
    this.isLoggedIn = AuthService.isLoggedIn()
    let vm = this
    EventBus.$on('isLoggedIn', function (isLoggedIn) {
      vm.isLoggedIn = isLoggedIn
    })
    if (window.localStorage.getItem('username') !== '') {
      this.me = window.localStorage.getItem('username')
    }
  },
  methods: {
    checkIfUserIsLoggedIn () {
      console.log('checkin if logged in')
      this.isLoggedIn = AuthService.isLoggedIn()
    }
  }
}
</script>

<style scoped>
  .navigation-bar {
    margin-bottom: 20px;
  }
  .navigation-item {
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue